import { registerBlock } from "../../../reaction-components";
import VariantInventoryForm from "./VariantInventoryForm";

registerBlock({
  region: "VariantDetailMain",
  name: "VariantInventoryForm",
  component: VariantInventoryForm,
  priority: 30
});
